import * as React from 'react';
import { useSelector } from 'react-redux';
import _ from 'lodash';

import { eventElementDataSelector, eventElementTypeSelector } from '@/redux/app/selectors/event';
import { EventElementType } from '@/constants/event-element-type.enum';

import { SmsMessage } from './SmsMessage';
import { MmsMessage } from './MmsMessage';
import { Call } from './Call';
import { OwnerChange } from './OwnerChange';
import { StatusChange } from './StatusChange';
import { CustomEvent } from './CustomEvent';
import { PendingMessage } from './PendingMessage';
import { EventNote } from './EventNote';
import { UnaddressedChange } from './UnaddressedChange';

export const Event = ({ id, ticket }: { id: string, ticket: string}) => {
  const elementType = useSelector(_.partial(eventElementTypeSelector, ticket, id));
  const elementData = useSelector(_.partial(eventElementDataSelector, ticket, id));
  switch (elementType) {
    case EventElementType.SMS:
      return <SmsMessage data={elementData} />;
    case EventElementType.MMS:
      return <MmsMessage data={elementData} ticket={ticket} eventId={id} />;
    case EventElementType.CALL:
      return <Call data={elementData} ticket={ticket} eventId={id} />;
    case EventElementType.OWNER_CHANGE:
      return <OwnerChange data={elementData} />;
    case EventElementType.STATUS_CHANGE:
      return <StatusChange data={elementData} />;
    case EventElementType.CUSTOM_EVENT:
      return <CustomEvent data={elementData} />;
    case EventElementType.PENDING_MESSAGE:
      return <PendingMessage data={elementData} ticket={ticket} eventId={id} />;
    case EventElementType.NOTE:
      return <EventNote data={elementData} />;
    case EventElementType.UNADDRESSED_CHANGE:
      return <UnaddressedChange data={elementData} />;
    default:
      return null;
  }
};
